import { render } from "./top-menu.vue?vue&type=template&id=1a6c72bc&scoped=true"
import script from "./top-menu.vue?vue&type=script&lang=js"
export * from "./top-menu.vue?vue&type=script&lang=js"

import "./top-menu.vue?vue&type=style&index=0&id=1a6c72bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c72bc"]])

export default __exports__